import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sign-in",
  "use": "sign-in-usage",
  "viewBox": "0 0 18.4 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.4 27\" id=\"sign-in\"><path d=\"M18.1 27h-15v-1.1h15V27zM0 26.6l2.3-7.3L14.5 1.1l4 2.6L6.1 22 0 26.6zm3.3-6.8l-1.2 3.8 3.3-2.5L16.9 4l-2.1-1.4L3.3 19.8zM9.6 6.3l-1-.6 4-5.7.9.6-3.9 5.7z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol